import {useTranslation} from 'react-i18next';
import {cn} from '@chekinapp/ui';
import type {UpsellItem} from '../useUpsellItems';

export function EsimStrip({item, className}: {item: UpsellItem; className?: string}) {
  const {t} = useTranslation();

  return (
    <div
      data-testid="home-esim-strip"
      className={cn(
        'relative isolate flex items-center gap-3 overflow-hidden rounded-[18px] px-4 py-3 text-[var(--chekin-color-white)]',
        className,
      )}
    >
      {item.imageUrl && (
        <img
          src={item.imageUrl}
          alt=""
          loading="lazy"
          className="absolute inset-0 -z-20 size-full object-cover"
        />
      )}
      <span
        aria-hidden
        className="absolute inset-0 -z-10 bg-[linear-gradient(115deg,color-mix(in_srgb,var(--chekin-orange)_92%,transparent)_4%,color-mix(in_srgb,var(--chekin-color-brand-blue)_70%,transparent))]"
      />
      <span className="min-w-0 flex-1">
        <span className="mb-1 inline-flex rounded-full bg-[color-mix(in_srgb,var(--chekin-color-white)_28%,transparent)] px-2 text-[12px] font-bold leading-[18px]">
          {t('travel_guide.sponsored')}
        </span>
        <span className="block text-[14px] font-bold leading-[18px]">
          {t('home_esim_title')}
        </span>
        {item.price && (
          <span className="block text-[12px] leading-4 opacity-90">
            {t('home_esim_provider', {price: item.price})}
          </span>
        )}
      </span>
      <button
        type="button"
        onClick={item.onSelect}
        className="h-[34px] shrink-0 rounded-[11px] bg-[var(--chekin-color-white)] px-3 text-[13px] font-bold text-[var(--chekin-color-brand-navy)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--chekin-color-white)] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
      >
        {item.ctaLabel}
      </button>
    </div>
  );
}
